import {Action, createReducer, on} from '@ngrx/store'
import {SamoobslugaStanInterface} from './types/samoobsluga-stan.interface'
import {samoobslugaStanPoczatkowy} from './samoobsluga.stan-poczatkowy'
import {pobierzDaneZgloszeniaSuccess, zainicjalizujToken} from 'src/app/init/store/init.actions'
import {pobierzDaneZgloszenia, zaktualizujStan, zaktualizujToken} from './samoobsluga.actions'
import {kliknietoRozpocznijSuccess} from '../../../samoobsluga/strona-startowa/store/strona-startowa.actions';
import {
  zapiszStorePoZmianieStanuNaKwotaUkryta
} from '../../../samoobsluga/proces-decyzji/ekran-braku-prezentacji-kwoty-po-kalkulacji/store/ekran-braku-prezentacji-kwoty-po-kalkulacji.actions';
import {
  kliknietoKalkulujSuccess,
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/ekran-podsumowania.actions';
import {
  pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty,
  pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/krok-po-kalkulacji/krok-po-kalkulacji.actions';

const initReducer = createReducer(
  samoobslugaStanPoczatkowy,
  on(zainicjalizujToken, (state, action) => {
    return ({...state, token: action.token})
  }),

  on(pobierzDaneZgloszenia, (state, action) => {
    return ({...state, correlationId: action.daneZgloszeniaZapytanie.correlationId})
  }),

  on(pobierzDaneZgloszeniaSuccess, kliknietoRozpocznijSuccess,
    kliknietoKalkulujSuccess,
    zapiszStorePoZmianieStanuNaKwotaUkryta, pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej,
    pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty,
    (state, action): SamoobslugaStanInterface => {
      return ({
        ...state,
        nrSzkody: action.daneZgloszenia.nrSzkody,
        stanSamoobslugi: action.stanSamoobslugi,
        tenant: action.daneZgloszenia.tenant,
        linkAnkieta: action.linkAnkieta
      })
    }),

  on(zaktualizujToken, (state, action) => {
    return ({...state, token: action.token})
  }),

  on(zaktualizujStan, (state, action) => {
    return ({...state, stanSamoobslugi: action.stanSamoobslugi})
  }),
)

export function samoobslugaReducers(state: SamoobslugaStanInterface, action: Action): SamoobslugaStanInterface {
  return initReducer(state, action)
}
